export default function slas(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                sla: action.sla,
            }
        default:
            return state;
    }
}
